import { createContext } from "react";

export const LoadingContext = createContext({
  loading: false,
  setIsLoading: (p: any) => {},
});
